import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import GroupBtnLight from 'modules/shared/Forms/GroupBtnLight';
import { setScanType } from './actions';
import { scanerBtnSelector } from './selectors';

type Props = {
  typeDoc: string;
  isDisabled: boolean;
  index?: number | null;
};

const ScanerBtn: React.FC<Props> = ({ typeDoc, isDisabled, index = null }) => {
  const dispatch = useDispatch();

  const { error, type, idx } = useSelector(scanerBtnSelector);
  const onScanDocument = () => {
    dispatch(setScanType(typeDoc, index));
  };

  return (
    <GroupBtnLight
      loading={false}
      // eslint-disable-next-line
      errorMsg={error?.message ? error.message : ''}
      isField={`${typeDoc}[${index}]`}
      isLoadingField={`${type}[${idx}]`}
      onClick={onScanDocument}
      disabled={isDisabled}
      btnIcon="documentScan"
    />
  );
};

export default ScanerBtn;
